import { createEntitySchemas, } from '../../../utils/normalize'

import { solicitudeSchemas } from './solicitude'
import { needsSchemas } from './needs'
import { peopleSchemas } from './people'
import { infoSchemas } from './info'
import { dataSchemas } from './data'
import { activitySchemas } from './acitivity'
import { financialSchemas } from './financial'
import { documentsInfoSchemas } from './documentInfo'
import { documentsSchemas } from './documents'

export const APPLICATION = 'applications'
export const applicationSchemas = createEntitySchemas(APPLICATION, {
  definitions: {
    solicitude: solicitudeSchemas.entity,
    needs: needsSchemas.entity,
    people: peopleSchemas.list,
    info: infoSchemas.list,
    data: dataSchemas.entity,
    activity: activitySchemas.entity,
    financial: financialSchemas.entity,
    document_info: documentsInfoSchemas.entity,
    documents: documentsSchemas.list
  }
})
